// context/GoogleMapsContext.js (or GoogleMapsProvider.js)
import { useEffect, useRef } from 'react';

export const GoogleMapsProvider = ({ children }) => {
  const loaded = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined' || loaded.current) return;

    const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!GOOGLE_MAPS_API_KEY) {
      console.warn('REACT_APP_GOOGLE_MAPS_API_KEY not set');
      return;
    }

    if (document.querySelector('#google-maps')) return;

    const script = document.createElement('script');
    script.id = 'google-maps';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    
    loaded.current = true;
  }, []);

  return children;
};
